// extracted by mini-css-extract-plugin
export default {"root":"notify_root__UuGtq","body":"notify_body__4f2bg","link":"notify_link__8IRn1"};